import { t } from 'localization/utils/t';

const TP = 'layout.header.enums.constantsFallback';

export const DESKTOP_HEADER_HEIGHT = '50px';
export const DESKTOP_HIDE_HEADER_HEIGHT = '-52px';
export const DESKTOP_HEADER_HEIGHT_NUMERIC = 50;

export const MOBILE_HEADER_HEIGHT = '50px';

export const NEW_NAV_MOBILE_HEADER_HEIGHT = '58px';
export const NEW_NAV_MOBILE_HIDE_HEADER_HEIGHT = '-61px';
export const NEW_NAV_MOBILE_HEADER_HEIGHT_NUMERIC = 58;

export const NAV_PDP_MOBILE_HEADER_HEIGHT = '50px';
export const NAV_PDP_MOBILE_HIDE_HEADER_HEIGHT = '-54px';

export const DEFAULT_ITEMS_COUNT = 200000;

export const NAVIGATION_BREADCRUMBS_FALLBACK = [
  {
    name: {
      value: t(`${TP}.featuredBrands`, 'Featured Brands'),
      TK: 'featuredBrands',
      TP,
    },
    slug: 'navigation/brand',
    sort: 1,
    children: [
      {
        name: 'Air Jordan',
        slug: 'brand/air-jordan',
        sort: 1,
      },
      {
        name: 'Alexander McQueen',
        slug: 'brand/alexander-mcqueen',
        sort: 2,
      },
      {
        name: 'Balenciaga',
        slug: 'brand/balenciaga',
        sort: 3,
      },
      {
        name: 'MCQ',
        slug: 'brand/mcq',
        sort: 4,
      },
      {
        name: 'Nike',
        slug: 'brand/nike',
        sort: 5,
      },
      {
        name: 'Off White',
        slug: 'brand/off-white',
        sort: 6,
      },
    ],
  },
  {
    name: {
      value: t(`${TP}.collections`, 'Collections'),
      TK: 'collections',
      TP,
    },
    slug: 'navigation/collections',
    sort: 2,
    children: [
      {
        name: {
          value: t(`${TP}.justDropped`, 'Just Dropped'),
          TK: 'justDropped',
          TP,
        },
        slug: 'collections/just-dropped',
        sort: 1,
      },
      {
        name: {
          value: t(`${TP}.newIn`, 'New In'),
          TK: 'newIn',
          TP,
        },
        slug: 'collections/new-arrivals-apparel',
        sort: 2,
      },
      {
        name: {
          value: t(`${TP}.goatSelects`, 'GOAT Selects'),
          TK: 'goatSelects',
          TP,
        },
        slug: 'collections/goat-selects',
        sort: 3,
      },
      {
        name: {
          value: t(`${TP}.mostWanted`, 'Most Wanted'),
          TK: 'mostWanted',
          TP,
        },
        slug: 'collections/most-wanted',
        sort: 4,
      },
    ],
  },
  {
    name: {
      value: t(`${TP}.categories`, 'Categories'),
      TK: 'categories',
      TP,
    },
    slug: 'navigation/category',
    sort: 3,
    children: [
      {
        name: {
          value: t(`${TP}.accessories`, 'Accessories'),
          TK: 'accessories',
          TP,
        },
        slug: 'accessories',
        sort: 1,
      },
      {
        name: {
          value: t(`${TP}.bags`, 'Bags'),
          TK: 'bags',
          TP,
        },
        slug: 'bags',
        sort: 2,
      },
      {
        name: {
          value: t(`${TP}.bottoms`, 'Bottoms'),
          TK: 'bottoms',
          TP,
        },
        slug: 'apparel/bottoms',
        sort: 3,
      },
      {
        name: {
          value: t(`${TP}.dresses`, 'Dresses'),
          TK: 'dresses',
          TP,
        },
        slug: 'apparel/dresses',
        sort: 4,
      },
      {
        name: {
          value: t(`${TP}.sneakers`, 'Sneakers'),
          TK: 'sneakers',
          TP,
        },
        slug: 'sneakers',
        sort: 5,
      },
      {
        name: {
          value: t(`${TP}.tops`, 'Tops'),
          TK: 'tops',
          TP,
        },
        slug: 'apparel/tops',
        sort: 6,
      },
    ],
  },
];

export const CALENDAR_BREADCRUMBS_FALLBACK = [
  {
    name: {
      value: t(`${TP}.newReleases`, 'New Releases'),
      TK: 'newRelease',
      TP,
    },
    slug: 'calendar/new',
    sort: 1,
    children: [
      {
        id: 694,
        name: "Wmns Dunk Low 'Photon Dust'",
        slug: 'mock-data-1',
        description: 'some description here',
        sort: 1,
      },
      {
        id: 695,
        name: "Wmns Dunk Low 'Barely Green'",
        slug: 'mock-data-2',
        sort: 2,
      },
      {
        id: 696,
        name: "Air Jordan 1 Retro High OG 'Shadow 2.0'",
        slug: 'mock-data-3',
        sort: 3,
      },
      {
        id: 697,
        name: "Yeezy 500 High 'Tactical Orange'",
        slug: 'mock-data-4',
        sort: 4,
      },
      {
        id: 698,
        name: "Yeezy 500 High 'Sumac'",
        slug: 'mock-data-5',
        sort: 5,
      },
      {
        id: 699,
        name: "Air Jordan 1 Retro High OG GS 'Shadow Something'",
        slug: 'mock-data-6',
        sort: 6,
      },
      {
        id: 700,
        name: "Dunk High SB 'TV Signal'",
        slug: 'mock-data-7',
        sort: 7,
      },
      {
        id: 701,
        name: "Air Jordan 5 Retro Low Wings 'Class of 2020'",
        slug: 'mock-data-8',
        sort: 8,
      },
    ],
  },
  {
    name: {
      value: t(`${TP}.upcomingReleases`, 'Upcoming Releases'),
      TK: 'upcomingReleases',
      TP,
    },
    slug: 'calendar/upcoming',
    sort: 1,
    children: [
      {
        id: 697,
        name: "Wmns Dunk High 'Photon Dust'",
        slug: 'mock-data-9',
        externalUrl: 'www.acne-studios.com',
        sort: 1,
      },
      {
        id: 698,
        name: "Wmns Dunk High 'Barely Green'",
        slug: 'mock-data-10',
        urlOverride: 'adidas-yeezy',
        sort: 2,
      },
      {
        id: 699,
        name: "Air Jordan 1 Retro Low OG 'Shadow 2.0'",
        slug: 'mock-data-11',
        urlOverride: 'adidas-yeezy',
        sort: 3,
      },
      {
        id: 700,
        name: "Yeezy 500 Low 'Tactical Orange'",
        slug: 'mock-data-12',
        urlOverride: 'adidas-yeezy',
        sort: 4,
      },
      {
        id: 701,
        name: "Yeezy 500 Low 'Sumac'",
        slug: 'mock-data-13',
        urlOverride: 'adidas-yeezy',
        sort: 5,
      },
      {
        id: 702,
        name: "Air Jordan 1 Retro Low OG GS 'Shadow Something'",
        slug: 'mock-data-14',
        urlOverride: 'adidas-yeezy',
        sort: 6,
      },
      {
        id: 703,
        name: "Dunk Low SB 'TV Signal'",
        slug: 'mock-data-15',
        urlOverride: 'adidas-yeezy',
        sort: 7,
      },
      {
        id: 704,
        name: "Air Jordan 5 Retro High Wings 'Class of 2020'",
        slug: 'mock-data-16',
        urlOverride: 'adidas-yeezy',
        sort: 8,
      },
    ],
  },
];
